import { TutorialTemplate } from "@components/templates";
import React from "react";

import tutorial3Image from "@assets/images/tutorial_3_image.png";
import styled from "styled-components";
import { Colors } from "@utils";

const Image = styled.img`
  width: 129px;
  height: 122px;
`;

const Tutorial3Page = () => {
  return (
    <TutorialTemplate page={3}>
      <div className="flex flex-col grow items-center justify-center">
        <Image src={tutorial3Image} />
        <div
          className="text-[18px]/[24px] font-[600] text-center whitespace-pre-wrap mt-[59px]"
          style={{ color: Colors.totallyBlack }}
        >
          안심하세요!{"\n"}건강성적표는 개인정보보호법을 준수하며{"\n"}입력한
          개인정보는 서비스 외에{"\n"}
          <b>다른 용도로 사용되지 않습니다 </b>
        </div>
      </div>
    </TutorialTemplate>
  );
};

export default Tutorial3Page;
